import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode; onReset?: () => void };
type State = { error: Error | null };

/** Isolates preview crashes from the rest of the admin/viewer shell. */
export class PreviewErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[preview]", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="preview-error card stack" role="alert">
          <p style={{ margin: 0 }}>Preview failed to render. Close and try again, or download the file.</p>
          <p className="muted" style={{ margin: 0, fontSize: 12 }}>
            {this.state.error.message}
          </p>
          <button
            type="button"
            className="secondary"
            onClick={() => {
              this.setState({ error: null });
              this.props.onReset?.();
            }}
          >
            Retry preview
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
